export default "__VITE_ASSET__98867bf2__"